import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import SettingsTabs from "../AllTabs/SettingsTabs";
const initialFieldValues = {
  companyId: "00000000-0000-0000-0000-000000000000",
  supplierId: "00000000-0000-0000-0000-000000000000",
  supplierName: "",
  agentCode: "",
  name: "",
  email: "",
  phoneNumber: "",
  city: "",
  address: "",
  isActive: true,
  apiType: "DEVELOPMENT",
  devapiurl: "",
  devapikey: "",
  devusername: "",
  devpassword: "",
  prodapiurl: "",
  prodapikey: "",
  produsername: "",
  prodpassword: "",
  type: "FLIGHT",
};
const Supplier = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [apiShow, setAPIShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAddShow(true);
  };
  const handleAPIClose = () => {
    setAPIShow(false);
    setRecordForEdit(null);
  };
  const handleAPIShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAPIShow(true);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
    const res = await apiService.get(
          `${config.GETCOMPANYSUPPLIERS}/${user?.cid}`,
          pageSize,
          pageNumber
        );
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const showAPIDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAPIShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETESUPPLIER, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
    }
  };
  const validate = () => {
    let temp = {};
    temp.supplierName = values.supplierName === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        supplierId: values.supplierId,
        supplierName: values.supplierName,
        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        city: values.city,
        address: values.address,
        isActive:
          values.isActive === "true"
            ? true
            : values.isActive === true
            ? true
            : false,
        apiType: values.apiType,
        devapiurl: values.devapiurl,
        devapikey: values.devapikey,
        devusername: values.devusername,
        devpassword: values.devpassword,
        prodapiurl: values.prodapiurl,
        prodapikey: values.prodapikey,
        produsername: values.produsername,
        prodpassword: values.prodpassword,
        agentCode: values.agentCode,
        type: values.type,
        companyId: user?.cid,
      };
      try {
        const isNew =
          formData.supplierId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATESUPPLIER, formData);
        } else {
          await apiService.update(config.UPDATESUPPLIER, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false); // ensure loading button resets even on error
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = ["supplierName", "city"];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setAPIShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <SettingsTabs pageName="SUPPLIER" />
                </div>                
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Supplier</th>
                          <th>Type</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th>API Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.supplierId}>
                              <td>{index + 1}</td>
                              <td>{v.companyName}</td>
                              <td>{v.type}</td>
                              <td>{v.name}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.email}</td>
                              <td>
                                {v.isActive === true ? (
                                  <span className="badge bg-success">
                                    ACTIVE
                                  </span>
                                ) : (
                                  <span className="badge bg-danger">
                                    IN-ACTIVE
                                  </span>
                                )}
                              </td>
                              <td>
                                {v.apiType === "DEVELOPMENT" ? (
                                  <span className="form-check-label badge bg-primary">
                                    {v.apiType}
                                  </span>
                                ) : (
                                  <span className="badge bg-success">
                                    {v.apiType}
                                  </span>
                                )}
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-info" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.supplierId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill text-danger align-bottom" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="APIKEYS"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) => showAPIDetails(v)}
                                    >
                                      <i className="ri-key-fill text-primary align-bottom" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header>
            <Modal.Title>
              {values.supplierId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Supplier
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-3 mb-3">
                  <label htmlFor="supplierName" className="form-label">
                    Supplier Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.supplierName}
                    name="supplierName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("supplierName")}
                    placeholder="Tripjack, TBO"
                  />
                  {errors.supplierName === false ? (
                    <div className="validationerror">
                      Please enter supplier name{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.name}
                    name="name"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("name")}
                    placeholder="Please enter name"
                  />
                  {errors.name === false ? (
                    <div className="validationerror">
                      Please enter name name{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("email")}
                    placeholder="Please enter email"
                  />
                  {errors.email === false ? (
                    <div className="validationerror">Please enter email </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    max={15}
                    value={values.phoneNumber}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("phoneNumber")}
                    placeholder="Please enter phone"
                  />
                  {errors.phoneNumber === false ? (
                    <div className="validationerror">
                      Please enter phone number{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="type" className="form-label">
                    Type
                  </label>
                  <select
                    name="type"
                    value={values.type}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("type")}
                  >
                    <option value="FLIGHT">FLIGHT</option>
                    <option value="HOTEL">HOTEL</option>
                    <option value="PACKAGES">PACKAGES</option>
                    <option value="BUS">BUS</option>
                    <option value="TRAINS">TRAINS</option>
                    <option value="CAR">CARS</option>
                    <option value="TRANSFER">TRANSFERS</option>
                    <option value="SIGHTSEEING">SIGHTSEEING</option>
                    <option value="VISA">VISAS</option>
                  </select>
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="isActive" className="form-label">
                    STATUS
                  </label>
                  <select
                    name="isActive"
                    value={values.isActive}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("isActive")}
                  >
                    <option value={true}>ACTIVE</option>
                    <option value={false}>IN-ACTIVE</option>
                  </select>
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.city}
                    name="city"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("city")}
                    placeholder="Please enter city"
                  />
                  {errors.city === false ? (
                    <div className="validationerror">Please enter city </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    value={values.address}
                    name="address"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("address")}
                    placeholder="Please enter address"
                  />
                  {errors.address === false ? (
                    <div className="validationerror">Please enter address </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.supplierId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal show={apiShow} onHide={handleAPIClose} size="lg">
          <Modal.Header>
            <Modal.Title>Supplier API Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-3 mb-3">
                  <label htmlFor="apiType" className="form-label">
                    Type
                  </label>
                  <select
                    name="apiType"
                    value={values.apiType}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("apiType")}
                  >
                    <option value="DEVELOPMENT">DEVELOPMENT</option>
                    <option value="PRODUCTION">PRODUCTION</option>
                  </select>
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="agentCode" className="form-label">
                    Agent Code
                  </label>
                  <input
                    type="text"
                    value={values.agentCode}
                    name="agentCode"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("agentCode")}
                    placeholder="Please enter agent code"
                  />
                </div>
                <div className="col-lg-6 mb-3"></div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="devapiurl" className="form-label">
                    DEV API URL
                  </label>
                  <input
                    type="text"
                    value={values.devapiurl}
                    name="devapiurl"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapiurl")}
                    placeholder="Please enter api url"
                  />
                  {errors.devapiurl === false ? (
                    <div className="validationerror">Please enter url </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="devapikey" className="form-label">
                    DEV API KEY
                  </label>
                  <input
                    type="text"
                    value={values.devapikey}
                    name="devapikey"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapikey")}
                    placeholder="Please enter key"
                  />
                  {errors.devapikey === false ? (
                    <div className="validationerror">Please enter key </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="devusername" className="form-label">
                    DEV API USERNAME
                  </label>
                  <input
                    type="text"
                    value={values.devusername}
                    name="devusername"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devusername")}
                    placeholder="Please enter username"
                  />
                  {errors.devusername === false ? (
                    <div className="validationerror">
                      Please enter devusername{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="devpassword" className="form-label">
                    DEV API PASSWORD
                  </label>
                  <input
                    type="text"
                    value={values.devpassword}
                    name="devpassword"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devpassword")}
                    placeholder="Please enter passord"
                  />
                  {errors.devpassword === false ? (
                    <div className="validationerror">
                      Please enter devpassword{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="prodapiurl" className="form-label">
                    PROD API URL
                  </label>
                  <input
                    type="text"
                    value={values.prodapiurl}
                    name="prodapiurl"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("devapiurl")}
                    placeholder="Please enter api url"
                  />
                  {errors.prodapiurl === false ? (
                    <div className="validationerror">Please enter url </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="prodapikey" className="form-label">
                    PROD API KEY
                  </label>
                  <input
                    type="text"
                    value={values.prodapikey}
                    name="prodapikey"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("prodapikey")}
                    placeholder="Please enter key"
                  />
                  {errors.prodapikey === false ? (
                    <div className="validationerror">Please enter key </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="produsername" className="form-label">
                    PROD API USERNAME
                  </label>
                  <input
                    type="text"
                    value={values.produsername}
                    name="produsername"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("produsername")}
                    placeholder="Please enter username"
                  />
                  {errors.produsername === false ? (
                    <div className="validationerror">
                      Please enter username{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-3 mb-3">
                  <label htmlFor="prodpassword" className="form-label">
                    PROD API PASSWORD
                  </label>
                  <input
                    type="text"
                    value={values.prodpassword}
                    name="prodpassword"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("prodpassword")}
                    placeholder="Please enter password"
                  />
                  {errors.prodpassword === false ? (
                    <div className="validationerror">
                      Please enter password{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <Modal.Footer>
                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                  {btnLoading === false ? (
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  ) : (
                    <button type="submit" className="btn btn-primary" disabled>
                      Please wait...
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleAPIClose}
                  >
                    Close
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default Supplier;
